import { getSelectedWakeLoopProfileId } from "./wakeloop-profile-selection";
import { resolveWakeLoopProfileByIdOrName } from "./wakeloop-profiles-api";

export async function resolveViewProfileKey(
  inputProfile?: string
): Promise<string | null> {
  const explicit = normalizeOptionalString(inputProfile);
  if (explicit) {
    const profile = await resolveWakeLoopProfileByIdOrName({
      profileIdentifier: explicit,
    }).catch(() => null);
    return profile?.wakeLoopProfileId ?? explicit;
  }

  const selected = await getSelectedWakeLoopProfileId();
  if (selected) {
    return selected;
  }

  return null;
}

function normalizeOptionalString(value: unknown): string | null {
  const normalized = String(value ?? "").trim();
  return normalized.length > 0 ? normalized : null;
}
